// extracted by mini-css-extract-plugin
export default {"link":"LeesMeer_link__GJDMY"};